import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="relative w-full py-24 md:py-32 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dramatic%20architectural%20interior%20with%20sweeping%20curved%20walls%20and%20soft%20diffused%20daylight%20casting%20long%20elegant%20shadows%20across%20a%20polished%20stone%20floor%2C%20contemporary%20gallery%20aesthetic%2C%20warm%20ivory%20and%20toasted%20almond%20tones%2C%20sculptural%20minimalism%2C%20serene%20luxury%20atmosphere%2C%20no%20text%2C%20no%20people%2C%20high-end%20interior%20design%20photography&width=1920&height=800&seq=cta-bg-v2&orientation=landscape"
          alt=""
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/50 via-black/35 to-black/25"></div>
      </div>

      <div className="relative z-10 max-w-[1440px] mx-auto px-6 md:px-10 lg:px-20">
        <div className="max-w-xl">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-semibold text-white leading-tight mb-4">
            Ready to Shop Smarter?
          </h2>
          <p className="text-base md:text-lg text-white/75 mb-8 leading-relaxed">
            Access the complete <strong className="text-white">hipobuy spreadsheet</strong> database and start discovering products organized by category with instant price comparison today.
          </p>
          <div className="flex flex-col sm:flex-row gap-3">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center justify-center gap-2 px-7 py-3.5 rounded-full bg-white text-foreground-950 font-semibold text-sm md:text-base whitespace-nowrap hover:bg-white/90 transition-colors cursor-pointer"
            >
              Buy It Now
              <span className="w-7 h-7 rounded-full bg-foreground-950 flex items-center justify-center">
                <i className="ri-arrow-right-line text-white text-sm"></i>
              </span>
            </a>
            <Link
              to="/hipobuy-spreadsheet-guide"
              className="inline-flex items-center justify-center gap-2 px-7 py-3.5 rounded-full bg-white/15 text-white border border-white/30 font-medium text-sm md:text-base whitespace-nowrap hover:bg-white/25 transition-colors cursor-pointer"
            >
              Read Shopping Guide
              <i className="ri-book-open-line text-base w-4 h-4 flex items-center justify-center"></i>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}